module.exports = __webpack_public_path__ + "static/headshot-74309a1ffa02c2251b5ff394274a0ac0.jpeg";